/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMasterOrder.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/master-order";

export class AutogenModelMasterOrder<RowType extends ModelRow> extends Endpoint<RowType, RowMasterOrderFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMasterOrder extends ModelRow<RowMasterOrderFields> {
	constructor(values?: Partial<RowMasterOrderFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMasterOrderFields {
	alt_partner_id: string;
	company_id: string;
	filter_type: string;
	id: string;
	name: string;
	partner_id: string;
	status_code: string;
	transaction_type: string;
	update_date: string;
	user_id: string;
	version: string;
}

